import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {useAppDispatch} from "../../utils/Hooks";
import {getOfflineReasons} from "../../store/reducers/OfflineReasonsSlice";
import {OfflineReasonsTable} from "./components/OfflineReasonsTable";

interface OfflineReasonsScreeProps {
}

export const OfflineReasonsScreen: React.FC<OfflineReasonsScreeProps> = () => {

    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getOfflineReasons());
    }, []);

    return (
        <LoggedInView fullWidth={false}>
            <h1>Miks väljas põhjused</h1>
            <OfflineReasonsTable />
        </LoggedInView>
    )

}